import { AlertCircle, BadgeCheck, X } from 'lucide-react';

export function Toast({ toasts, dismiss }) {
  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 200,
      display: 'flex', flexDirection: 'column', gap: 8,
    }}>
      {toasts.map(t => (
        <div key={t.id} className="fade-in" style={{
          background: 'var(--bg-inverse)', color: 'var(--ink-inverse)',
          padding: '12px 14px 12px 16px',
          borderRadius: 'var(--radius)', minWidth: 280,
          display: 'flex', alignItems: 'center', gap: 10,
          boxShadow: 'var(--shadow-lg)', fontSize: 13.5,
        }}>
          {t.type === 'error' ? (
            <AlertCircle size={16} style={{ color: '#fca5a5' }} />
          ) : (
            <BadgeCheck size={16} style={{ color: '#86efac' }} />
          )}
          <span style={{ flex: 1 }}>{t.message}</span>
          <button onClick={() => dismiss(t.id)} style={{
            background: 'transparent', border: 'none', color: 'var(--ink-inverse)',
            opacity: .6, cursor: 'pointer', padding: 2,
          }}><X size={14} /></button>
        </div>
      ))}
    </div>
  );
}
